import ConfirmationDialog from 'tio-reimagined/components/confirmation-dialog';
import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';

export interface DeleteAccountConfirmationModalSignature {
  Element: HTMLElement;
  Args: {
    isOpen: boolean;
    isReceivingContributions?: boolean;
    onClose: () => void;
    onSubmit: () => void | Promise<void>;
  };
}

const DeleteAccountConfirmationModal: TOC<DeleteAccountConfirmationModalSignature> = <template>
  <ConfirmationDialog
    @isOpen={{@isOpen}}
    @onCancel={{@onClose}}
    @onConfirm={{@onSubmit}}
    @title={{t "common.accounts.delete"}}
    @intent="danger"
    @confirmText={{t "common.accounts.delete"}}
  >
    <p class="font-semibold mb-4">{{t "common.accounts.delete_modal_body" htmlSafe=true}}</p>
    {{#if @isReceivingContributions}}
      <p class="text-gray-500">
        {{t "common.accounts.delete_contributions_disclaimer"}}
      </p>
    {{/if}}
  </ConfirmationDialog>
</template>;

export default DeleteAccountConfirmationModal;
